// GENERATED FILE, PLEASE DO NOT EDIT
export var ButtonPrimaryToggle = 2;
export var ButtonPrimaryToggleOff = 2;
export var ButtonSecondaryToggle = 2;
export var ButtonSecondaryToggleOff = 2;
export var ButtonTertiaryToggle = 2;
export var ButtonTertiaryToggleOff = 2;
export var ButtonPrimaryToggleGroupOn = 1;
export var ButtonPrimaryToggleGroupOff = 1;
export var ButtonSecondaryToggleGroupOn = 1;
export var ButtonSecondaryToggleGroupOff = 1;
export var ButtonTertiaryToggleGroupOn = 1;
export var ButtonTertiaryToggleGroupOff = 1;
export var FieldsDefault = 1;
export var FieldsError = 2;
export var FieldsFocus = 2;
export var PaginationNumbered = 1;
export var PaginationNumberedUnselected = 1;
export var Toggle = 2;